import React, { FC } from 'react'
import styles from './RangePickerFooter.module.scss'
import { InfoCircleOutlined } from '@ant-design/icons'
import Button from 'UI/Button/Button'

interface RangePickerFooter {
  text: string
  onSubmit: () => void
}

const RangePickerFooter: FC<RangePickerFooter> = ({ text, onSubmit }) => {
  return (
    <div className={styles.container}>
      <InfoCircleOutlined className={styles.icon} />
      <div className={styles.text}>{text}</div>
      <Button buttonType='primary' className={styles.button} onClick={onSubmit}>
        Ok
      </Button>
    </div>
  )
}

export default RangePickerFooter
